<mat-toolbar mat-dialog-title>
  <mat-toolbar-row>
    <h1 mat-dialog-title>{{title | appTranslate}}</h1>
  </mat-toolbar-row>
</mat-toolbar>
<div mat-dialog-content>
  <h6>{{message | appTranslate}}</h6>
</div>
<div align="end" mat-dialog-actions>
  <button (click)="dialogRef.close(false)" color="accent" mat-raised-button>
    {{cancelLabel | appTranslate}}
  </button>
  <button (click)="dialogRef.close(true)" color="primary" mat-raised-button>
    {{confirmLabel | appTranslate}}
  </button>
</div>
